import React, { useContext, useEffect, useReducer } from 'react'
import reducers from './reducers'
import Action from '../model/Action'
import State from '../model/State'
import entidadeService from '../services/EntidadeService'
import {
    setEntidades, setAuthenticated, setTotal, setUsuario, setIsLoading
} from './actions'
import api from '../services/api'
import UsuarioService from '../services/UsuarioService'

interface providerState {
    provider: State,
    dispatch: React.Dispatch<Action>
}

const initialState: State = {
    entidades: {
        items: [],
        total: 0,
        query: {
            limit: 6,
            page: 1,
            search: '',
            area: '',
            city: '',
            type: '',
            admin: false
        },
        isLoading: false
    },
    currentEntidade: {
        id: -1,
        areaDeAtuacao: [],
        descricao: '',
        email: '',
        fase: 'IDEAÇÃO',
        faturamento: 0,
        localizacao: {
            bairro: '', cidade: '', complemento: '', logradouro: '', numero: 0
        },
        logo: '',
        metas: '',
        nome: '',
        pitch: '',
        publicoAlvo: 'B2B',
        site: '',
        tamanhoEquipe: 0,
        telefone: '',
        tipoEntidade: []
    },
    authenticated: false
}

const AppContext = React.createContext<providerState>({
    provider: initialState,
    dispatch: () => {}
})

export default function Provider(props: any) {
    const { children } = props
    const [provider, dispatch] = useReducer(reducers, initialState)
    const { entidades: { query } } = provider

    useEffect(() => {
        const token = localStorage.getItem('token')

        if (token) {
            api.defaults.headers.common.Authorization = `Token ${token}`
            setAuthenticated(dispatch, true)
            UsuarioService.get().then((user) => {
                setUsuario(dispatch, user)
            })
        }
    }, [])

    useEffect(() => {
        setIsLoading(dispatch, true)
        entidadeService.get(query).then((data) => {
            setEntidades(dispatch, data.items)
            setTotal(dispatch, data.total)
            setIsLoading(dispatch, false)
        })
    }, [query])

    return (
        <AppContext.Provider value={{ provider, dispatch }}>
            {children}
        </AppContext.Provider>
    )
}

export function useProvider() {
    const { provider, dispatch } = useContext(AppContext)
    const {
        entidades, usuario, authenticated, currentEntidade
    } = provider
    const { query } = entidades

    async function loadEntidades() {
        await entidadeService.get(query).then((data) => {
            setEntidades(dispatch, data.items)
            setTotal(dispatch, data.total)
        })
    }

    return {
        entidades,
        usuario,
        authenticated,
        currentEntidade,
        loadEntidades,
        dispatch
    }
}
